import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { userRole_proctor } from '../appConstant';
import { AppGlobals } from '../Services/app.global';

@Injectable()
export class ManageProctorsGuard implements CanActivate {
  constructor(
    private _appGlobals: AppGlobals,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return combineLatest(this._appGlobals.acType, this._appGlobals.userInfo).map(([acType, userInfo]) => {
        return acType === userRole_proctor && userInfo.isProctorLead;
      });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/guards/manage-proctors.guard.ts